import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	categories: [
		{
			title: 'Нашите услуги',
			content: [
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-compare-hosting-plans.php" title="Хостинг">Хостинг</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'managed-wp-hosting.php" title="Хостинг за WordPress + AI">Хостинг за WordPress + AI</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'wp-hosting.php" title="Хостинг за WordPress">Хостинг за WordPress</a>'
				},

				{
					link: '<a href="' + getInitialMeta('siteURL') + 'wp-support.php" title="Професионална поддръжка за WordPress">Професионална поддръжка за WordPress</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-common-managed-vps.php" title="Managed VPS">Managed VPS</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-servers-vps.php" title="VPS">VPS</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-servers-dedicated.php" title="Наети сървъри">Наети сървъри</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'site-builder-ai.php" title="Site Builder">Site Builder AI</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-compare-shop-plans.php" title="Shopiko">Shopiko</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-register-domains.php" title="Домейни">Домейни</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-certificates.php" title="SSL сертификати">SSL сертификати</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'gdpr-protect-iubenda" title="GDPR Protect">GDPR Protect</a>'
				}
			]
		},
		{
			title: 'За Superhosting',
			content: [
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-about-company.php" title="За нас">За нас</a>'
				},
				{
					link: '<a href="https://superhosting.teamtailor.com/" title="Кариери">Кариери</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-contact.php" title="За контакт">За контакт</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'super-partners" title="Нашите партньори">Нашите партньори</a>'
				}
			]
		},
		{
			title: 'Полезни ресурси',
			content: [
				{
					link: '<a href="https://blog.superhosting.bg" title="СуперБлог" target="_blank" rel="noopener noreferrer">СуперБлог</a>'
				},
				{
					link: '<a href="https://help.superhosting.bg" title="Помощна страница" target="_blank" rel="noopener noreferrer">Помощна страница</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-dsa-annual-report.php" title="Годишен отчет (ЗДУ)">Годишен отчет (ЗДУ)</a>'
				}
			]
		},
		{
			title: 'Клиентски профил',
			content: [
				{
					link: '<a href="' + getInitialMeta('profileUrl') + '" title="Вход в профила">Вход в профила</a>'
				},
				{
					link: '<a href="' + getInitialMeta('profileUrl') + 'web-hosting-client-hosting.php" title="Хостинг акаунти">Хостинг акаунти</a>'
				},
				{
					link: '<a href="' + getInitialMeta('profileUrl') + 'web-hosting-client-domain-edit-list.php" title="Управление на домейни">Управление на домейни</a>'
				},
				{
					link: '<a href="' + getInitialMeta('profileUrl') + 'web-hosting-client-renew-services.php" title="Подновяване на услуги">Подновяване на услуги</a>'
				}
			]
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	categories: [
		{
			title: 'Our services',
			content: [
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-compare-hosting-plans.php" title="Hosting">Hosting</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'managed-wp-hosting.php" title="Hosting for WordPress + AI">Hosting for WordPress + AI</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'wp-hosting.php" title="Hosting for WordPress">Hosting for WordPress</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'wp-support.php" title="Professional support for WordPress">Professional support for WordPress</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-common-managed-vps.php" title="Managed VPS">Managed VPS</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-servers-vps.php" title="Virtual Servers (VPS)">Virtual Servers (VPS)</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-servers-dedicated.php" title="Dedicated Servers">Dedicated Servers</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'site-builder-ai.php" title="Site Builder">Site Builder AI</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-compare-shop-plans.php" title="Shopiko">Shopiko</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-register-domains.php" title="Domains">Domains</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-certificates.php" title="SSL Certificates">SSL Certificates</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'gdpr-protect-iubenda" title="GDPR Protect">GDPR Protect</a>'
				}
			]
		},
		{
			title: 'About SuperHosting',
			content: [
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-about-company.php" title="About us">About us</a>'
				},
				{
					link: '<a href="https://superhosting.teamtailor.com/" title="Careers">Careers</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-contact.php" title="Contact us">Contact us</a>'
				}
			]
		},
		{
			title: 'Resource Hub',
			content: [
				{
					link: '<a href="https://blog.superhosting.bg/en" title="SuperBlog" target="_blank" rel="noopener noreferrer">SuperBlog</a>'
				},
				{
					link: '<a href="https://help.superhosting.bg/en" title="Help topics" target="_blank" rel="noopener noreferrer">Help topics</a>'
				},
				{
					link: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-dsa-annual-report.php" title="DSA Annual Report">DSA Annual Report</a>'
				}
			]
		},
		{
			title: 'Customer profile',
			content: [
				{
					link: '<a href="https://my.superhosting.bg" title="Login">Login</a>'
				},
				{
					link: '<a href="https://my.superhosting.bg/web-hosting-client-hosting.php" title="Hosting accounts">Hosting accounts</a>'
				},
				{
					link: '<a href="https://my.superhosting.bg/web-hosting-client-domain-edit-list.php" title="Domain Management">Domain Management</a>'
				},
				{
					link: '<a href="https://my.superhosting.bg/web-hosting-client-renew-services.php" title="Service Renewal">Service Renewal</a>'
				}
			]
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];